<template>
    <el-dialog :title="title" append-to-body :close-on-click-modal="false" width="804px" v-model="visible">
      <div class="edit-style">
        <div class="edit-style-bgset">
          <div class="edit-style-bgset-title">背景图片</div>
          <div class="edit-style-bgset-nav">
            <div class="edit-style-bgset-nav-item" :class="{ active: bgSetIndex === 1 }" @click="bgSetIndex = 1">扁平化</div>
            <div class="edit-style-bgset-nav-item" :class="{ active: bgSetIndex === 2 }" @click="bgSetIndex = 2">渐变</div>
          </div>
          <div class="edit-style-bgset-content">
            <lUpload style="margin-right: 8px;" v-model:imgurl="bgSelect" :uploadStyle="{ width: '87px', height: '37px', borderRadius: '2px' }" />
            <template v-if="bgSetIndex === 1">
              <div class="edit-style-bgset-content-item" v-for="(item, index) in 10" :key="index" :class="{ 'img-active': bgSetIndex === 1 && bgSelect === `basemap/${item}.png` }" @click="bgSelect = `basemap/${item}.png`">
                <img :src="`https://bigdata.topeti.com/PCRepository/middleground/home/icon/basemap/${item}.png`" />
              </div>
            </template>
            <template v-else-if="bgSetIndex === 2">
              <div class="edit-style-bgset-content-item" v-for="(item, index) in 4" :key="index" :class="{ 'img-active': bgSetIndex === 2 && bgSelect === `gradient/${item}.png` }" @click="bgSelect = `gradient/${item}.png`">
                <img :src="`https://bigdata.topeti.com/PCRepository/middleground/home/icon/gradient/${item}.png`" />
              </div>
            </template>
          </div>
        </div>
        <div class="edit-style-body">
          <div class="header">
            <el-dropdown @command="add" trigger="click" placement="bottom">
              <i class="iconfont icon-tianjia2"></i>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="text">文本</el-dropdown-item>
                  <el-dropdown-item command="img">图片</el-dropdown-item>
                  <el-dropdown-item command="icon">图标</el-dropdown-item>
                  <el-dropdown-item command="button">按钮</el-dropdown-item>
                  <el-dropdown-item command="weather">天气</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <div class="body">
            <el-scrollbar ref="elScroll" :key="barKey" :class="[parseInt(modelW) < 720 ? 'model-center' : '', parseInt(modelH) < 450 && parseInt(modelW) < 720 ? 'flex-center' : '']" style="height: 100%;">
              <div class="body-container" @mousedown="mouseDown" ref="bodyContainer" :style="[{width: modelW, height: modelH, transform:`matrix(${scale}, 0, 0, ${scale}, ${endX}, ${endY})`, cursor: isSpaceKey ? 'move': 'default'}]">
                <div class="container-bg" draggeable="false" v-if="getBg">
                  <img class="container-bg-img" :src="getBg" style="user-select: none;-webkit-user-drag:none ">
                </div>
                <VueDraggableResizable class="draggeable" :handles="['tl','tr','br','bl']" v-for="(item,index) in config" :w="item.w" :h="item.h" :x="item.x" :y="item.y" :key="item.id" :parent="true" classNameActive="drag-active"
                  @resizestop="(left, top, width, height)=> onResizstop(left, top, width, height, item)"
                  @dragstop="(left, top)=> onDragstop(left, top, item)" :draggable="!isSpaceKey" :style="{ background: item.type === 'text' ? 'transparent' : '' }">
                  <div class="draggeable-item">
                    <div class="model">
                      <el-popover
                        placement="bottom"
                        popper-class="edit-pop"
                        width="218"
                        v-model="isViewText"
                        visible-arrow
                        :disabled="true"
                        trigger="click">
                        <template #reference>
                          <i class="iconfont icon-bianji1" v-if="item.type !== 'weather'" @click.stop="toolEdit(item,index)"></i>
                          <i v-if="item.type === 'img'" class="iconfont icon-bianliang" @click="parmsSet(item, index)"></i>
                          <i class="iconfont icon-a-shanchu2x" @click="delConfig(index)"></i>
                        </template>
                        <!-- <logoEdit class="text-edit" @change-all-font="changeText" @change-top-content="item.info.text = $event" @close="isViewText = false" :columnFont="item.info.fontStyle" :topContent="item.info.text"/> -->
                      </el-popover>
                    </div>
                    <template v-if="item.type === 'text'">
                      <!-- <textVue :info="item.info"></textVue> -->
                      <div class="rich-text" v-html="item.info.text"></div>
                    </template>
                    <template v-else-if="item.type === 'weather'">
                      <weatherComp />
                    </template>
                    <template v-else-if="item.type === 'img'">
                      <el-image style="width: 100%;height: 100%;" fit="fill" :src="getImgUrl(item.info)">
                        <template #error>
                          <div class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                          </div>
                        </template>
                      </el-image>
                    </template>
                    <template v-else-if="item.type === 'button'">
                      <buttonComp class="style-btn" :info="{ info: item.info }"></buttonComp>
                    </template>
                    <template v-else-if="item.type === 'icon'">
                      <icon-module :config="item.info"></icon-module>
                    </template>
                  </div>
                </VueDraggableResizable>
              </div>
            </el-scrollbar>
          </div>
          <div class="scall">
            <div class="scall-slider">
              <span class="iconjian" @click="goReduce">－</span>
              <el-slider :min="1" :max="20" :step="0.5" :format-tooltip="formatSlider" style="flex:1" :show-input="false" input-size="mini" v-model="scaleSlider"></el-slider>
              <span @click="goAdd" class="el-icon-plus"></span>
            </div>
            <el-select class="scall-select" v-model="scaleSelect" @change="scallSelectChange">
              <el-option v-for="item in scallList" :label="item" :value="item" :key="item"></el-option>
            </el-select>
          </div>
        </div>
        <div class="edit-style-foot">
          <div>
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="confirm">确定</el-button>
          </div>
        </div>
        <input type="file" hidden ref="upload" @input="uploadChange" />
        <icon-part ref="iconpart" @confirm="iconConfirm"></icon-part>
        <TodoNavItem v-model:isViews="isViewButton" :isOutSide="false" :isStyleEdit="true" :info="goEdit ? goEdit.info : {}" @on-success="btnConfirm"></TodoNavItem>
        <imagesEdit v-model:isView="isViewImagesEdit" :currentValue='goEdit' @imgEidtCB='imgEidtCallBack' />
        <!-- 富文本修改 -->
        <richTextEdit @close="isEdit = false" @submit="richTextEditCallBack" :functionParms="goEdit && goEdit.functionParms ? goEdit.functionParms : []" :isMobile="isMobile" ref="richTextEdit" />
      </div>
    </el-dialog>
</template>

<script>
import { confileRes } from '@/api/utils'
import VueDraggableResizable from 'vue3-draggable-resizable'
import { getConfig, uploadImg } from './config'
import buttonComp from '@/components/schoolInstrument/component/mutual/component/button/buttonStyle.vue'
import iconMixins from '../icon/common'
import { cloneDeep } from 'lodash'
// import TodoNavItem from '@/components/admins/workBench/moreSetting/mycomponent/mutual/components/dialog/todoNavItem.vue'
import lUpload from './components/imagesEdit/lUpload.vue'
import { defineAsyncComponent } from 'vue'
export default {
  // 组件名称
  name: 'editStyle',
  mixins: [iconMixins],
  // 组件参数 接收来自父组件的数据
  props: {
    title: {
      type: String,
      default: '编辑'
    },
    modelW: {
      type: String,
      default: '400px'
    },
    modelH: {
      type: String,
      default: '300px'
    },
    dataInfo: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      defa: ''
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    customData: {
      type: Array,
      default: () => []
    }
  },
  // 局部注册的组件
  components: {
    VueDraggableResizable,
    buttonComp,
    // TodoNavItem,
    lUpload,
    imagesEdit: defineAsyncComponent(() => import('./components/imagesEdit')),
    richTextEdit: defineAsyncComponent(() => import('@/components/common/richTextEditDia.vue')),
    weatherComp: defineAsyncComponent(() => import('./components/weather')),
  },
  // 组件状态值
  data () {
    return {
      visible: false,
      config: [],
      curType: '',
      goEdit: null,
      goEditIndex: -1,
      isViewText: false,
      isViewButton: false,
      isViewImagesEdit: false,
      scallList: ['10%', '25%', '50%', '75%', '100%', '150%', '200%'],
      scaleSlider: 10,
      scaleSelect: '100%',
      scale: 1,
      barKey: 0,
      isSpaceKey: false,
      endX: 0,
      endY: 0,
      isEdit: false,
      bgSetIndex: 1,
      bgSelect: ''
    }
  },
  // 计算属性
  computed: {
    getBg () {
      const info = this.dataInfo
      if (this.type === 'roll') {
        const img = info.imgTempUrl
        return this.$imgurl + img
      } else if (this.type === 'boutique') {
        let url = ''
        if (info.backgroundCustomize === 0) {
          url = this.$imgurl + info.autonomyBackground
        } else {
          url = `https://bigdata.topeti.com/PCRepository/middleground/home/icon/basemap/${info.backgroundCustomize}.png`
        }
        return url
      } else {
        if (this.bgSelect.includes('img-')) {
          return this.$imgurl + this.bgSelect
        } else if (this.bgSelect) {
          return 'https://bigdata.topeti.com/PCRepository/middleground/home/icon/' + this.bgSelect
        } else {
          return ''
        }
      }
    }
  },
  // 侦听器
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.init()
        } else {
          this.delInit()
        }
      },
      immediate: true
    },
    scaleSlider (val) {
      const scale = val / 10
      this.scale = scale
    },
    scale () {
      this.barKey++
    }
  },
  // 组件方法
  methods: {
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      const isGIF = file.type === 'image/gif'
      const isJPEG = file.type === 'image/jpeg'
      const isWEPB = file.type === 'image/webp'

      if (!isJPG && !isPNG && !isGIF && !isJPEG && !isWEPB) {
        this.$message.error('上传头像图片只能是 JPG或png或gif或jpeg 格式!')
      }
      const isLt2M = file.size / 1048576 < 5
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return (
        (isJPG && isLt2M) ||
        (isPNG && isLt2M) ||
        (isGIF && isLt2M) ||
        (isJPEG && isLt2M) ||
        (isWEPB && isLt2M)
      )
    },
    getImgUrl (info) {
      let url = info.url
      // 存在变量就使用变量
      if (info.parms) {
        const _parms = info.parms
        if (_parms.name === '当前用户') {
          let userMsg = localStorage.getItem('userMsg')
          if (userMsg) {
            userMsg = JSON.parse(userMsg)
            if (userMsg[_parms.userValue]) {
              url = userMsg[_parms.userValue]
            }
          }
        } else {
          const val = _parms.value && Array.isArray(_parms.value) && _parms.value.length > 0 ? _parms.value[0] : ''
          if (val) {
            this.$http.getuserbindmsg({ userId: val.userId }).then(res => {
              if (res.code === 0 && res.data) {
                url = res.data[_parms.userValue]
              }
            })
          }
        }
      }
      return this.$imgurl + url
    },
    // 文本组件回调
    richTextEditCallBack ({ formData, functionParms }) {
      this.isEdit = false
      this.config[this.goEditIndex].info.text = formData
      this.config[this.goEditIndex].info.functionParms = functionParms
    },
    // 图片编辑回调
    imgEidtCallBack (val) {
      this.config[this.goEditIndex].info.parms = val
    },
    handleBackSuccess (res) {
      // 文件读取成功完成时触发
      this.bgSelect = confileRes(res)
    },
    init () {
      try {
      // 除了火狐、IE的写法                                //火狐兼容写法
        window.addEventListener('mousewheel', this.mousewheel, { passive: false }) || window.addEventListener('DOMMouseScroll', this.mousewheel, { passive: false })
      } catch (e) {
      // IE兼容写法
        window.attachEvent('mousewheel', this.mousewheel, { passive: false })
      }
      document.addEventListener('keydown', this.keydown)
      document.addEventListener('keyup', this.keyup)
      document.addEventListener('click', this.hiddenTextEdit)
    },
    delInit () {
      try {
      // 除了火狐、IE的写法                                //火狐兼容写法
        window.removeEventListener('mousewheel', this.mousewheel, { passive: false }) || window.removeEventListener('DOMMouseScroll', this.mousewheel, { passive: false })
      } catch (e) {
      // IE兼容写法
        window.detachEvent('mousewheel', this.mousewheel, { passive: false })
      }
      document.removeEventListener('keydown', this.keydown)
      document.removeEventListener('keyup', this.keyup)
      document.removeEventListener('click', this.hiddenTextEdit)
    },
    mouseDown (e) {
      const disX = e.clientX
      const disY = e.clientY
      const endX = this.endX
      const endY = this.endY
      document.onmousemove = e => {
        const l = e.clientX - disX
        const t = e.clientY - disY
        if (this.isSpaceKey) {
          this.endX = endX + l
          this.endY = endY + t
        }
        // if (this.isSpaceKey) {
        //   const elScroll = this.$refs.elScroll
        //   if (elScroll && elScroll.wrap) {
        //     const ele = elScroll.wrap
        //     console.dir(ele)
        //     const scrollLeft = ele.scrollLeft
        //     const scrollTop = ele.scrollLeft
        //     const scrollH = ele.scrollHeight
        //     const scrollW = ele.scrollWidth
        //     let top = scrollTop - l
        //     let left = scrollLeft - t
        //     // console.log(top, left, 'top-left')
        //     if (top < 0) {
        //       top = 0
        //     }
        //     if (top > scrollH) {
        //       top = scrollH
        //     }
        //     if (left < 0) {
        //       left = 0
        //     }
        //     if (left > scrollW) {
        //       left = scrollW
        //     }
        //     ele.scrollTo({
        //       left,
        //       top,
        //       behavior: 'smooth'
        //     })
        //   }
        // }
      }
      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
      }
    },
    keydown (e) {
      if (!this.isEdit && e.keyCode === 32 && e.code === 'Space') {
        e.preventDefault()
        if (this.isSpaceKey === true) return
        this.isSpaceKey = true
        const elScroll = this.$refs.elScroll
        if (elScroll && elScroll.wrapRef) {
          // const ele = elScroll.wrap
          // ele.scrollTo({
          //   left: 10,
          //   top: 0,
          //   behavior: 'smooth'
          // })
        }
      }
    },
    keyup (e) {
      if (e.keyCode === 32 && e.code === 'Space') {
        e.preventDefault()
        this.isSpaceKey = false
      }
    },
    mousewheel (e) {
      if (e.ctrlKey === true || e.metaKey) {
        e.preventDefault()
        if (e.wheelDelta) { // 判断浏览器IE，谷歌滑轮事件
          if (e.wheelDelta > 0) { // 当滑轮向上滚动时
            this.scaleSlider += 1
          }
          if (e.wheelDelta < 0) { // 当滑轮向下滚动时
            this.scaleSlider -= 1
          }
        } else if (e.detail) { // Firefox滑轮事件
          if (e.detail > 0) { // 当滑轮向上滚动时
            this.scaleSlider += 1
          }
          if (e.detail < 0) { // 当滑轮向下滚动时
            this.scaleSlider -= 1
          }
        }
      }
    },
    scallSelectChange (val) {
      const scale = parseInt(val) / 100
      const scaleSlider = parseInt(val) / 10
      this.scale = scale
      this.scaleSlider = scaleSlider
    },
    formatSlider (value) {
      return `${value * 10}%`
    },
    goReduce () {
      if (this.scaleSlider <= 1) return
      this.scaleSlider -= 0.5
    },
    goAdd () {
      if (this.scaleSlider >= 20) return
      this.scaleSlider += 0.5
    },
    onResizstop (x, y, w, h, item) {
      item.x = x
      item.y = y
      item.w = w
      item.h = h
    },
    onDrag (x, y, item) {
      item.x = x
      item.y = y
    },
    onDragstop (x, y, item) {
      item.x = x
      item.y = y
    },
    add (val) {
      this.curType = val
      if (val === 'text' || val === 'button' || val === 'weather') {
        const data = getConfig(val, this.config)
        this.config.push(data)
      } else if (val === 'img') {
        // 打开上传
        // this.$refs.upload.click()
        const date = getConfig(this.curType, this.config)
        date.info.url = ''
        this.config.push(date)
        // this.config.push(date)
        // this.isViewImagesEdit = true
      } else if (val === 'icon') {
        this.$refs.iconpart.open()
      }
    },
    toolEdit (item, index) {
      this.goEdit = item
      this.goEditIndex = index
      if (item.type === 'text') {
        this.isEdit = true
        const info = cloneDeep(item.info)
        info.bindinf = info.text
        this.$refs.richTextEdit.open(info, this.customData)
      } else if (item.type === 'icon') {
        this.$refs.iconpart.open(item.info)
      } else if (item.type === 'img') {
        this.$refs.upload.click()
      } else if (item.type === 'button') {
        this.isViewButton = true
      }
    },
    // 变量设置
    parmsSet (item, index) {
      console.log(item, index)
      this.goEdit = item
      this.goEditIndex = index
      if (item.type === 'text') {
        // TODO
      } else if (item.type === 'img') {
        this.isViewImagesEdit = true
      }
    },
    changeText (val) {
      // 改变文本组件样式
      const date = this.goEdit
      if (date) {
        date.info.fontStyle = val
        this.config[this.goEditIndex] = date
      }
    },
    hiddenTextEdit () {
      // 点击任意地方隐藏文本组件编辑
      // this.isViewText = false
      // if (this.curType === 'text') {
      //   this.goEdit = null
      //   this.goEditIndex = -1
      // }
    },
    open (config, opt = {}) {
      if (config && Array.isArray(config)) {
        this.config = cloneDeep(config)
      }
      const { bgSelect } = opt
      this.bgSelect = bgSelect
      if (!(parseInt(this.modelH) < 450 && parseInt(this.modelW) < 720)) {
        this.endY = 230 - (parseInt(this.modelH) / 2)
      }
      this.visible = true
    },
    async uploadChange (e) {
      const file = e.target.files[0]
      if (!file) return
      const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
      const apiurl = this.$apiurl + '/userfile/upload?accesstoken='+token
      const url = await uploadImg(file, apiurl)
      if (this.goEdit === null && this.goEditIndex === -1) {
        const date = getConfig(this.curType, this.config)
        date.info.url = url
        this.config.push(date)
      } else {
        const date = cloneDeep(this.goEdit)
        date.info.url = url
        this.config[this.goEditIndex] = date
        this.goEdit = null
        this.goEditIndex = -1
      }
    },
    iconConfirm (config) {
      if (this.goEdit === null && this.goEditIndex === -1) {
        const date = getConfig(this.curType, this.config)
        date.info = config
        this.config.push(date)
      } else {
        const date = cloneDeep(this.goEdit)
        date.info = config
        this.config[this.goEditIndex] = date
        this.goEdit = null
        this.goEditIndex = -1
      }
    },
    btnConfirm (config) {
      const data = cloneDeep(config)
      const date = cloneDeep(this.goEdit)
      date.info = data
      this.config[this.goEditIndex] = date
      this.goEdit = null
      this.goEditIndex = -1
    },
    delConfig (idx) {
      this.config.splice(idx, 1)
    },
    confirm () {
      this.$emit('on-success', this.config, { bgSelect: this.bgSelect })
      this.close()
    },
    close () {
      const initialData = this.$options.data.call(this)
      Object.assign(this.$data, initialData)
      this.visible = false
    }
  }
}
</script>
<style lang="scss">
.edit-pop {
  padding: 0 !important;
  overflow: visible !important;
}
.image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(245, 247, 250, 1);
  font-size: 30px;
}
.rich-text {
  p {
    margin: 15px 0;
  }
  img {
    cursor: default;
    display: inline !important;
    max-width: 100%;
    min-height: 20px;
    min-width: 20px;
  }
}
</style>

<style scoped lang="scss">
::v-deep .el-dialog {
    .el-dialog__header {
      border-bottom: solid 1px #eeeeee;
    }
    .el-dialog__body {
      padding: 0;
      .edit-style-bgset {
        position: absolute;
        width: 320px;
        height: 100%;
        background-color: #fff;
        right: -319px;
        top: 0;
        border-left: solid 1px #eeeeee;
        box-sizing: border-box;
        padding: 0 20px;
        &-title {
          margin: 10px 0;
          color: #333333;
          font-weight: 600;
          font-size: 14px;
        }
        &-nav {
          display: flex;
          margin-bottom: 20px;
          &-item {
            height: 34px;
            line-height: 34px;
            cursor: pointer;
            margin-right: 10px;
            &:last-of-type {
              margin-right: 0;
            }
          }
          .active {
            color: #4E86FF;
            border-bottom: solid 2px #4E86FF;
          }
        }
        &-content {
          display: flex;
          flex-wrap: wrap;
          .img-active {
            border-color: #4E86FF !important;
          }
          &-item {
            &:nth-child(3n) {
              margin-bottom: 8px;
              margin-right: 0;
            }
            width: 87px;
            height: 37px;
            border-radius: 2px;
            border: solid 1px #d9d9d9;
            box-sizing: border-box;
            margin-right: 8px;
            cursor: pointer;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .edit-style {
        &-body {
            padding: 20px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            .header {
                display: flex;
                width: 100%;
                margin-bottom: 10px;
                justify-content: flex-end;
                .set {
                    color: #4E86FF;
                    cursor: pointer;
                    user-select: none;
                    margin-right: 16px;
                    display: flex;
                    align-items: center;
                    i {
                        margin-left: 5px;
                    }
                }
                .icon-tianjia2 {
                    color: #4E86FF;
                    cursor: pointer;
                }
            }
            .body {
              width: 100%;
              height: 460px;
              background-color: #F8F9FB;
              .model-center {
                .el-scrollbar__view {
                  text-align: center;
                }
              }
              .flex-center {
                .el-scrollbar__view {
                  height: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
              }
              .el-scrollbar__wrap {
                overflow-x: hidden;
              }
              &-container {
                background-color: #fff;
                display: inline-block;
                position: relative;
                transform-origin: left top;
                .container-bg {
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 100%;
                  height: 100%;
                  -webkit-user-drag: none;
                  pointer-events: none;
                  user-select: none;
                  overflow: hidden;
                  &-img {
                    width: 100%;
                    -webkit-user-drag: none;
                    pointer-events: none;
                    user-select: none;
                  }
                }
              }
              .drag-active {
                border: dashed 1px #4E86FF !important;
                z-index: 999 !important;
                .model {
                  visibility: visible !important;
                }
                .handle {
                  width: 5px !important;
                  height: 5px !important;
                  border-radius: 50%;
                  border-color: #4E86FF;
                  background-color: #4E86FF;
                }
                .handle-tl {
                  top: -2.5px !important;
                  left: -2.5px !important;
                }
                .handle-br {
                  bottom: -2.5px !important;
                  right: -2.5px !important;
                }
                .handle-tr {
                  top: -2.5px !important;
                  right: -2.5px !important;
                }
                .handle-bl {
                  bottom: -2.5px !important;
                  left: -2.5px !important;
                }
              }
              .draggeable {
                border-radius: 4px;
                border: dashed 1px transparent;
                &-item {
                  width: 100%;
                  height: 100%;
                  user-select: none;
                  .style-btn {
                    width: 100%;
                    .btn-one {
                      width: 100%;
                    }
                    .btn-five {
                      width: 100%;
                    }
                    .btn-two {
                      width: 100%;
                      justify-content: flex-start;
                    }
                  }
                }
                .model {
                  position: absolute;
                  padding: 6px 10px;
                  right: -77px;
                  bottom: 0;
                  background-color: rgba(0, 0, 0, .63);
                  display: flex;
                  border-radius: 4px;
                  visibility: hidden;
                  .text-edit {
                    position: absolute;
                    top: 20px;
                    left: 20px;
                  }
                  .iconfont {
                    color: #fff;
                    font-size: 12px;
                    margin-left: 10px;
                    cursor: pointer;
                    &:hover {
                      color: #4E86FF;
                    }
                  }
                  .icon-bianji1 {
                    margin-left: 0;
                  }
                }
              }
            }
            .scall {
              width: 100%;
              display: flex;
              justify-content: flex-end;
              height: 50px;
              align-items: center;
              margin-bottom: -10px;
              &-slider {
                display: flex;
                align-items: center;
                height: 100%;
                width: 260px;
                margin-right: 20px;
                .iconjian {
                  width: 25px;
                  text-align: center;
                  color: #333333;
                  font-weight: 500;
                  font-size: 30px;
                  margin-right: 15px;
                  box-sizing: border-box;
                  cursor: pointer;
                  line-height: 50px;
                  user-select: none;
                }
                .el-icon-plus {
                  color: #333333;
                  font-weight: 600;
                  margin-left: 20px;
                  cursor: pointer;
                }
              }
              &-select {
                width: 90px;
                .el-input__inner {
                  line-height: 36px;
                  height: 36px;
                }
                .el-input__suffix {
                  .el-select__caret {
                    line-height: 36px;
                  }
                }
              }
            }
        }
        &-foot {
            width: 100%;
            height: 68px;
            display: flex;
            align-items: center;
            padding: 0 24px;
            justify-content: flex-end;
            box-sizing: border-box;
            border-top: solid 1px #eee;
            .el-button {
                width: 72px;
                height: 32px;
                line-height: 32px;
                padding: 0;
            }
            .el-button--primary {
                background-color: rgba(5, 126, 255, 1);
                border-color: rgba(5, 126, 255, 1);
            }
        }
      }
    }
  }
</style>
